// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import {
//   Box,
//   Grid,
//   Typography,
//   TextField,
//   Autocomplete,
//   Checkbox,
//   MenuItem,
//   CircularProgress,
// } from "@mui/material";

// import { useNavigate, useLocation } from "react-router-dom";
// import { PiPencilSimpleLineLight } from "react-icons/pi";
// import { CiMobile3 } from "react-icons/ci";
// import { RxCross2 } from "react-icons/rx";
// import styles from "./Candidate.module.css";
// import { useDispatch, useSelector } from "react-redux";
// import { resumeProcces } from "../../redux/internal-tracking/InternalTrackerSlice";
// import { addSkill, allSkill } from "../../redux/common/skillSlice";
// import {
//   addWorkAuthorization,
//   allWorkAuthorization,
// } from "../../redux/common/workAuthorizationSlice";
// import { addLocation, allLocation } from "../../redux/common/locationSlice";
// import { customTextColor, whichFile } from "../../utils/const";

// import { createSelector } from "reselect";
// import isEqual from "lodash/isEqual";
// import { createHotList } from "../../redux/hotlist/hotListSlice";

// import CandidateListDrawer from "./CandidateListDrawer";

// // Redux selectors
// const selectTracker = (state) => state.tracker;
// const selectSkill = (state) => state.skill;
// const selectWorkAutho = (state) => state.workautho;
// const selectLocation = (state) => state.location;

// export const selectResumeData = createSelector(
//   [selectTracker],
//   (tracker) => tracker.resumeData
// );
// export const selectSkillData = createSelector(
//   [selectSkill],
//   (skill) => skill.data?.locations || []
// );
// export const selectWorkAuthoData = createSelector(
//   [selectWorkAutho],
//   (workautho) => workautho.data?.work_authorization_data || []
// );
// export const selectLocationsData = createSelector(
//   [selectLocation],
//   (location) => location.data?.locations || []
// );

// // Gender options

// const CreateHotlist = ({ show, handleClose, hotListID, hotListTitle }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const stableDispatch = useCallback(dispatch, []);
//   const location = useLocation();

//   const [showCandidateListDrawer, setShowCandidateListDrawer] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [isEditingTitle, setIsEditingTitle] = useState(
//     !hotListID || !hotListTitle
//   );
//   const [title, setTitle] = useState(hotListTitle || "My Hotlist for Active");
//   const [hotListId, setHotListId] = useState(hotListID);

//   // Handle file upload

//   // Trigger updates when resumeData or hasProcessedResume changes

//   // Handle returnSelectedFileName

//   // Handle resume field

//   const handleButtonClick = () => {
//     document.getElementById("fileInput").click();
//   };

//   const handleTitleChange = (event) => {
//     setTitle(event.target.value);
//   };

//   const handleEditTitle = () => {
//     if (isEditingTitle) {
//       setIsEditingTitle(false);
//     } else {
//       setIsEditingTitle(true);
//     }
//   };

//   const handleCloseCandidateListDrawer = useCallback(() => {
//     setShowCandidateListDrawer(false);
//   }, []);

//   return (
//     <Offcanvas
//       show={show}
//       onHide={handleClose}
//       placement="end"
//       scroll={true}
//       backdrop={false}
//       style={{
//         border: "none",
//         marginTop: "65px",
//         width: "60%",
//         boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
//         <Box sx={{ padding: "10px 10px" }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "0px 10px",
//             }}
//           >
//             {isEditingTitle ? (
//               <TextField
//                 value={title}
//                 onChange={handleTitleChange}
//                 onBlur={handleEditTitle}
//                 onKeyPress={(e) => {
//                   if (e.key === "Enter") handleEditTitle();
//                 }}
//                 autoFocus
//                 variant="standard"
//                 sx={{ flexGrow: 1, marginRight: "10px" }}
//                 inputProps={{
//                   style: { color: customTextColor, fontWeight: "bold" },
//                 }}
//               />
//             ) : (
//               <Typography
//                 style={{
//                   color: customTextColor,
//                   fontWeight: "bold",
//                   cursor: hotListId ? "default" : "pointer",
//                 }}
//                 onClick={hotListId ? null : handleEditTitle}
//               >
//                 {title}{" "}
//                 {!hotListId && (
//                   <PiPencilSimpleLineLight style={{ marginLeft: "5px" }} />
//                 )}
//               </Typography>
//             )}
//             <RxCross2
//               style={{
//                 fontSize: "15px",
//                 cursor: "pointer",
//                 color: customTextColor,
//               }}
//               onClick={handleClose}
//             />
//           </Box>
//           <Box
//             className={styles.upload_resume_section}
//             sx={{
//               padding: "5px 15px",
//               margin: "5px 10px",
//               borderRadius: "3px",
//               bgcolor: "#f5f5f5",
//               mt: 1,
//             }}
//           >
//             <Box style={{ color: customTextColor }} sx={{ marginTop: "10px" }}>
//               <Typography
//                 sx={{
//                   marginBottom: "2px !important",
//                   fontSize: "20px !important",
//                 }}
//               >
//                 Unlimited Hotlist – Not Be Limit
//               </Typography>
//               <Typography>
//                 Boost highest possibility reaching to recruiters by filling
//                 below details
//               </Typography>
//             </Box>
//             <Box textAlign={"right"} sx={{ marginTop: "10px" }}>
//               <button
//                 // onClick={handleButtonClick}
//                 disabled={loading}
//                 onClick={() => {
//                   setShowCandidateListDrawer(true);
//                 }}
//                 // style={loading ? { padding: "7px 40px" } : {}}
//               >
//                 Add Candidate
//               </button>
//             </Box>
//           </Box>
//         </Box>
//         {showCandidateListDrawer && (
//           <CandidateListDrawer
//             show={showCandidateListDrawer}
//             handleClose={handleCloseCandidateListDrawer}
//             hotListName={title}
//           />
//         )}
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

// export default CreateHotlist;

import React, { useState, useEffect, useCallback, useMemo } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  Box,
  Typography,
  TextField,
  CircularProgress,
  Tooltip,
  Grid,
  Button,
  DialogContent,
  DialogActions,
  Dialog, // Added for tooltip
} from "@mui/material";

import { useNavigate, useLocation } from "react-router-dom";
import { PiPencilSimpleLineLight } from "react-icons/pi";
import { RxCross2 } from "react-icons/rx";
import styles from "./Candidate.module.css";
import { useDispatch, useSelector } from "react-redux";
import { resumeProcces } from "../../redux/internal-tracking/InternalTrackerSlice";
import { addSkill, allSkill } from "../../redux/common/skillSlice";
import {
  addWorkAuthorization,
  allWorkAuthorization,
} from "../../redux/common/workAuthorizationSlice";
import { addLocation, allLocation } from "../../redux/common/locationSlice";
import { customTextColor, whichFile } from "../../utils/const";

import { createSelector } from "reselect";
import isEqual from "lodash/isEqual";
import {
  createHotList,
  deleteCandidate,
  getCandidateList,
} from "../../redux/hotlist/hotListSlice";

import CandidateListDrawer from "./CandidateListDrawer";
import { Icon } from "@iconify/react/dist/iconify.js";
import { styled } from "@mui/system";
import ViewCandidateDrawer from "./ViewCandidateDrawer";

// Redux selectors
const selectTracker = (state) => state.tracker;
const selectSkill = (state) => state.skill;
const selectWorkAutho = (state) => state.workautho;
const selectLocation = (state) => state.location;

export const selectResumeData = createSelector(
  [selectTracker],
  (tracker) => tracker.resumeData
);
export const selectSkillData = createSelector(
  [selectSkill],
  (skill) => skill.data?.locations || []
);
export const selectWorkAuthoData = createSelector(
  [selectWorkAutho],
  (workautho) => workautho.data?.work_authorization_data || []
);
export const selectLocationsData = createSelector(
  [selectLocation],
  (location) => location.data?.locations || []
);

const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: theme.spacing(0.5),
  backgroundColor: "#f0f0f0",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#d0d0f0",
  },
}));

const CreateHotlist = ({ show, handleClose, hotListID, hotListTitle }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stableDispatch = useCallback(dispatch, []);
  const locations = useSelector((state) => state.location) || [];
  const candidateListLoading = useSelector(
    (state) => state.hotlist.loading.getCandidateList
  );
  const candidateList = useSelector((state) => state.hotlist.candidates);
  const workautho = useSelector((state) => state.workautho);
  const [showCandidateListDrawer, setShowCandidateListDrawer] = useState(false);
  const [candidateToDelete, setCandidateToDelete] = useState(null);
  const [showViewCandidateDrawer, setShowViewCandidateDrawer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isEditingTitle, setIsEditingTitle] = useState(
    !hotListID || !hotListTitle
  );
  const [title, setTitle] = useState(hotListTitle || "My Hotlist");
  const [hotListId, setHotListId] = useState(hotListID);
  const [showEditDrawer, setShowEditDrawer] = useState(false);

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleEditTitle = () => {
    if (isEditingTitle) {
      setIsEditingTitle(false);
    } else {
      setIsEditingTitle(true);
    }
  };

  const handleCloseCandidateListDrawer = useCallback(() => {
    setShowCandidateListDrawer(false);
  }, []);

  const handleCreateHotlist = async () => {
    if (!title.trim()) {
      alert("Hotlist title cannot be empty.");
      return;
    }

    setIsCreating(true);
    try {
      const payload = { name: title };
      const response = await dispatch(createHotList(payload)).unwrap();
      console.log("Hotlist created successfully:", response);

      if (response && response.id) {
        setHotListId(response.id);
        setIsEditingTitle(false);
      }
    } catch (error) {
      console.error("Error creating hotlist:", error);
      alert("Failed to create hotlist. Please try again.");
    } finally {
      setIsCreating(false);
    }
  };

  const handleOpenDialog = (candidate) => {
    setCandidateToDelete(candidate);
    setOpenDialog(true);
  };

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name || "N/A";
  };
  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name || "N/A";
  };

  const getPreferLocationNames = (preferLocation) => {
    return (
      preferLocation
        ?.map(
          (id) =>
            locations?.data?.locations?.find((location) => location.id === id)
              ?.name
        )
        ?.filter(Boolean)
        ?.join(", ") || "N/A"
    );
  };

  const handleEditCandidate = (candidate) => {
    setSelectedCandidate(candidate);
    setShowEditDrawer(true);
  };

  const handleConfirmDelete = async () => {
    console.log(`Deleted profile for ${candidateToDelete?.full_name}`);
    await dispatch(deleteCandidate(candidateToDelete?.id));
    setOpenDialog(false);
    setCandidateToDelete(null);
  };
  const handleCancelDelete = () => {
    setOpenDialog(false);
    setCandidateToDelete(null);
  };

  useEffect(() => {
    if (hotListId) {
      dispatch(getCandidateList(hotListId));
    }
  }, [dispatch, hotListId]);

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, [dispatch]);

  const handleCloseViewCandidateDrawer = () => {
    setShowViewCandidateDrawer(false);
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "60%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px 10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 10px",
            }}
          >
            {isEditingTitle ? (
              <TextField
                value={title}
                onChange={handleTitleChange}
                onBlur={handleEditTitle}
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleEditTitle();
                }}
                autoFocus
                variant="standard"
                sx={{ flexGrow: 1, marginRight: "10px" }}
                inputProps={{
                  style: { color: customTextColor, fontWeight: "bold" },
                }}
              />
            ) : (
              <Typography
                style={{
                  color: customTextColor,
                  fontWeight: "bold",
                  cursor: hotListId ? "default" : "pointer",
                }}
                onClick={hotListId ? null : handleEditTitle}
              >
                {title}{" "}
                {!hotListId && (
                  <PiPencilSimpleLineLight style={{ marginLeft: "5px" }} />
                )}
              </Typography>
            )}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {!hotListId && (
                <Box>
                  <button
                    onClick={handleCreateHotlist}
                    disabled={isCreating}
                    style={
                      isCreating
                        ? {
                            backgroundColor: "#2e75b6",
                            border: "none",
                            borderRadius: "3px",
                            color: "#fff",
                            padding: "3px 8px",
                            cursor: "default",
                          }
                        : {
                            backgroundColor: "#2e75b6",
                            border: "none",
                            borderRadius: "3px",
                            color: "#fff",
                            padding: "3px 8px",
                            cursor: "pointer",
                          }
                    }
                  >
                    {isCreating ? <CircularProgress size={20} /> : "Create"}
                  </button>
                </Box>
              )}
              <RxCross2
                style={{
                  fontSize: "15px",
                  marginLeft: "5px",
                  cursor: "pointer",
                  color: customTextColor,
                }}
                onClick={handleClose}
              />
            </Box>
          </Box>
          <Box
            className={styles.upload_resume_section}
            sx={{
              padding: "5px 15px",
              margin: "5px 10px",
              borderRadius: "3px",
              bgcolor: "#f5f5f5",
              mt: 1,
            }}
          >
            <Box style={{ color: customTextColor }} sx={{ marginTop: "10px" }}>
              <Typography
                sx={{
                  marginBottom: "2px !important",
                  fontSize: "20px !important",
                }}
              >
                Unlimited Hotlist – Not Be Limit
              </Typography>
              <Typography>
                Boost highest possibility reaching to recruiters by filling
                below details
              </Typography>
            </Box>
            <Box textAlign={"right"} sx={{ marginTop: "10px" }}>
              <Tooltip
                title={
                  !hotListId
                    ? "Please create the hotlist before adding candidates"
                    : ""
                }
                placement="top"
              >
                <span>
                  <button
                    disabled={loading || !hotListId} // Disable if loading or hotListId is not set
                    onClick={() => {
                      setShowCandidateListDrawer(true);
                    }}
                    style={
                      loading || !hotListId
                        ? {
                            backgroundColor: "#ccc",
                            border: "none",
                            borderRadius: "3px",
                            color: "#fff",
                            padding: "8px 16px",
                            cursor: "not-allowed",
                          }
                        : {
                            backgroundColor: "#2e75b6",
                            border: "none",
                            borderRadius: "3px",
                            color: "#fff",
                            padding: "8px 16px",
                            cursor: "pointer",
                          }
                    }
                  >
                    Add Candidate
                  </button>
                </span>
              </Tooltip>
            </Box>
          </Box>
          {hotListId && (
            <Box sx={{ mx: 1.2 }}>
              {" "}
              {candidateListLoading === "pending" && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                    py: 5,
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
              {candidateListLoading !== "pending" &&
                candidateList?.map((candidate, index) => (
                  <Grid
                    container
                    key={index}
                    sx={{
                      padding: "14px",
                      mb: "10px",
                      borderRadius: "3px",
                      border: "1px solid #e0e0e0",
                      alignItems: "center",
                    }}
                  >
                    <Grid item xs={6}>
                      <ul
                        style={{
                          listStyleType: "square",
                          paddingLeft: "20px",
                          margin: 0,
                        }}
                      >
                        <li>
                          <Typography style={{ fontSize: "14px" }}>
                            Name: <b>{candidate.full_name}</b>
                          </Typography>
                        </li>
                        <li>
                          <Typography style={{ fontSize: "14px" }}>
                            Job Profile: <b>{candidate.current_job_title}</b>
                          </Typography>
                        </li>
                        <li>
                          <Typography style={{ fontSize: "14px" }}>
                            Current Location:{" "}
                            <b>
                              {getLocationById(candidate?.current_location)}
                            </b>
                          </Typography>
                        </li>
                        <li>
                          <Typography style={{ fontSize: "14px" }}>
                            Rate: <b>${candidate.rate} Hourly</b>
                          </Typography>
                        </li>
                      </ul>
                    </Grid>
                    <Grid item xs={6}>
                      <ul
                        style={{
                          listStyleType: "square",
                          paddingLeft: "20px",
                          margin: 0,
                        }}
                      >
                        <li>
                          <Typography style={{ fontSize: "14px" }}>
                            Visa:{" "}
                            <b>
                              {getWorkAuthorization(
                                candidate?.work_authorization
                              )}
                            </b>
                          </Typography>
                        </li>
                        <li>
                          <Typography style={{ fontSize: "14px" }}>
                            Experience:{" "}
                            <b>
                              {candidate.total_experience < 1
                                ? `${Math.round(
                                    candidate.total_experience * 12
                                  )} Months`
                                : `${candidate.total_experience} ${
                                    candidate.total_experience === 1
                                      ? "Year"
                                      : "Years"
                                  }`}
                            </b>
                          </Typography>
                        </li>
                        <li>
                          <Typography style={{ fontSize: "14px" }}>
                            Prefer Location:{" "}
                            <b>
                              {getPreferLocationNames(
                                candidate?.prefer_location
                              )}
                            </b>
                          </Typography>
                        </li>
                        <li>
                          <Typography style={{ fontSize: "14px" }}>
                            Relocate:{" "}
                            <b>
                              {candidate?.willing_to_relocate ? "Yes" : "No"}
                            </b>
                          </Typography>
                        </li>
                      </ul>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        mt: "5px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          marginTop: "5px",
                          backgroundColor: "#d9d9d9",
                          textTransform: "capitalize",
                          borderRadius: "3px",
                          boxShadow: "none",
                          color: "#000",
                          padding: "4px 8px",
                          "&:hover": {
                            backgroundColor: "#b8b8b8",
                            boxShadow: "none",
                          },
                        }}
                        onClick={() => {
                          setShowViewCandidateDrawer(true);
                          setSelectedCandidate(candidate);
                        }}
                      >
                        View More
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        mt: "5px",
                      }}
                    >
                      <ActionButton
                        color="inherit"
                        onClick={() => handleEditCandidate(candidate)}
                        sx={{
                          backgroundColor: "#00b0f0",
                          borderRadius: "3px",
                          padding: "6px",
                          "&:hover": {
                            backgroundColor: "#33a8c7",
                          },
                        }}
                      >
                        <Icon
                          icon="carbon:edit"
                          width="20px"
                          height="20px"
                          color="#ffff"
                        />
                      </ActionButton>
                      <ActionButton
                        color="inherit"
                        onClick={() => handleOpenDialog(candidate)}
                        sx={{
                          backgroundColor: "#e76f51",
                          borderRadius: "3px",
                          padding: "6px",
                          "&:hover": {
                            backgroundColor: "#d65a4a",
                          },
                        }}
                      >
                        <Icon
                          icon="fluent:delete-24-regular"
                          width="20px"
                          height="20px"
                          color="#ffff"
                        />
                      </ActionButton>
                    </Grid>
                  </Grid>
                ))}
            </Box>
          )}
        </Box>
        {showCandidateListDrawer && (
          <CandidateListDrawer
            show={showCandidateListDrawer}
            handleClose={handleCloseCandidateListDrawer}
            hotListName={title}
            hotListId={hotListId}
            candidateList={candidateList}
          />
        )}
        {showViewCandidateDrawer && (
          <ViewCandidateDrawer
            show={showViewCandidateDrawer}
            handleClose={handleCloseViewCandidateDrawer}
            selectedCandidate={selectedCandidate}
          />
        )}

        <Dialog open={openDialog} onClose={handleCancelDelete}>
          <DialogContent>
            <Typography>
              Hi, {candidateToDelete?.full_name}. Are you sure, that you want to
              delete this profile?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ mr: "14px", mb: "10px" }}>
            <Button
              variant="contained"
              onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#00b0f0",
                textTransform: "capitalize",
                borderRadius: "3px",
                boxShadow: "none",
                padding: "6px 14px",
                "&:hover": {
                  backgroundColor: "#0085b4",
                  boxShadow: "none",
                },
              }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={handleCancelDelete}
              sx={{
                backgroundColor: "#e76f51",
                textTransform: "capitalize",
                borderRadius: "3px",
                boxShadow: "none",
                padding: "6px 14px",
                "&:hover": {
                  backgroundColor: "#d65a4a",
                  boxShadow: "none",
                },
              }}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CreateHotlist;
